import { ShipmentType, UITab } from '@constants';
import loadable from '@loadable/component';
import { UIUtils } from '@utils';
import { memo, useCallback, useMemo, useRef, useState } from 'react';
import trans from 'translation';
import { KBreadcrumbs, KContainer, KTab, KTabInstance } from 'uikit';
import { useMount } from 'uikit-common';

const AutoFill = loadable(() => import('./components/AutoFill'));
import ListContainer from './List.Container';
import ListGeneralFreight from './List.GeneralFreight';

const List = () => {
  const tabRef = useRef<KTabInstance>(null);

  const [tabIndex, setTabIndex] = useState(0);

  const [shipmentType, setShipmentType] = useState(ShipmentType.FCL);

  useMount(() => {
    tabRef.current?.onChange(0);
  });

  const tabs = useMemo(
    () => [
      {
        code: UITab.Container,
        label: trans('container')
      },
      {
        code: UITab.GeneralFreight,
        label: trans('general_freight')
      }
    ],
    []
  );

  const onAutofill = useCallback(() => {
    UIUtils.popup.open({
      title: trans('autofill'),
      content: () => <AutoFill shipmentType={shipmentType} />
    });
  }, [shipmentType]);

  const onChangeTab = useCallback(
    (idx: number) => {
      setTabIndex(idx);
      if (idx === tabs.findIndex(i => i.code === UITab.Container)) {
        setShipmentType(ShipmentType.FCL);
      } else {
        setShipmentType(ShipmentType.LCL);
      }
    },
    [tabs]
  );

  return (
    <>
      <KBreadcrumbs
        hasBackIcon={false}
        title={trans('routes.transport_job')}
        rightNode={{
          buttons: [
            {
              type: 'outline',
              props: {
                title: trans('autofill'),
                icon: 'Publish',
                onPress: onAutofill
              }
            }
          ]
        }}
      />
      <KContainer.View padding="0.75rem">
        <KTab.White
          ref={tabRef}
          tabIndex={tabIndex}
          onChangeTab={onChangeTab}
          tabs={tabs}
        />
        <KTab.Panel
          value={tabIndex}
          index={tabs.findIndex(i => i.code === UITab.Container)}
        >
          <ListContainer />
        </KTab.Panel>

        <KTab.Panel
          value={tabIndex}
          index={tabs.findIndex(i => i.code === UITab.GeneralFreight)}
        >
          <ListGeneralFreight
            shipmentType={shipmentType}
            onChangeShipmentType={setShipmentType}
          />
        </KTab.Panel>
      </KContainer.View>
    </>
  );
};

export default memo(List);
